import React from "react"
import { useParams } from "react-router"

import { PermissionGate } from "../../../../../../components/PermissionGate/PermissionGate.tsx"
import ProjectViewChecklistsChartSection from "./ProjectViewChecklistsChartSection.tsx"
import ProjectViewChecklistsListSection from "./ProjectViewChecklistsListSection/ProjectViewChecklistsListSection.tsx"

const ProjectViewChecklistsSection = () => {
  const projectId = useParams()?.id as string

  return (
    <div className={"overflow-auto space-y-6"}>
      <PermissionGate
        paths={["projects.checklists.project_checklist_view_burndown_chart"]}
        hideOnDenied
      >
        <ProjectViewChecklistsChartSection projectId={projectId} />
      </PermissionGate>

      <ProjectViewChecklistsListSection projectId={projectId} />
    </div>
  )
}

// const mapStateToProps = (state: RootState) => ({})
// const mapDispatchToProps = {}
//
// const connector = connect(mapStateToProps, mapDispatchToProps)
export default ProjectViewChecklistsSection
